(function ($) {

    'use strict';

    const isLazyLoadEnabled = fascinate_pro_ajax_script.lazy_load === '1' ? true : false;
    const enableStickySidebar = fascinate_pro_ajax_script.sticky_sidebar === '1' ? true : false;
    const enableBackToTop = fascinate_pro_ajax_script.back_to_top === '1' ? true : false;
    const stickyHeader = fascinate_pro_ajax_script.sticky_header === '1' ? true : false;
    const enablePreloader = fascinate_pro_ajax_script.preloader === '1' ? true : false;
    const isRTL = fascinate_pro_ajax_script.isRTL === '1' ? true : false;

    const FASPRO = {

        ready: function () {

            // Hooked: on document ready
            this.lazyLoad();
            this.toolTip();
            this.primaryNav();
            this.canvas();
            this.ajaxLoadPosts();
            this.loadAllSliders();
            this.loadMasonry();
            this.handleSearch();
            this.handleBackToTopEvent();

            if (enableStickySidebar) {

                this.stickySidebar();
            }
        },

        resize: function () {

            // Hooked: on window resize event.

            if (enableStickySidebar) {

                this.stickySidebar();
            }
        },

        scroll: function () {

            // Hooked: on window scroll event.
            if (enableBackToTop) {

                this.watchBackToTopButtonVisibility();
            }

            if (stickyHeader) {

                this.stickyHeader();
            }
        },

        /**
        * Enable lazy loading.
        * 
        * @return void
        * @since 1.0.0
        */
        lazyLoad: function () {

            if (isLazyLoadEnabled) {

                window.lazySizesConfig = window.lazySizesConfig || {};
                lazySizesConfig.preloadAfterLoad = false;
                lazySizesConfig.expandChild = 370;

                document.addEventListener('lazyloaded', function (e) {

                    e.target.parentNode.classList.add('image-loaded');

                    $.when().done(function () {

                        let cloele = $('.lazy-thumb');
                        cloele.removeClass('lazyloading');
                    });
                });
            }
        },

        /**
        * Enable tooltip
        * 
        * @return void
        * @since 1.0.0
        */
        toolTip: function () {

            if (typeof tippy === 'function') {

                tippy('.fascinate-pro-tooltip', {
                    content: "",
                    arrow: true,
                    delay: 50,
                    duration: 500,
                    animation: 'scale'
                });

            } else {

                console.warn("Fascinate Pro: Tippy is not defined, Skipping initialization.....");
            }
        },

        /**
        * Extend primary navigation.
        * 
        * @return void
        * @since 1.0.0
        */
        primaryNav: function () {

            $('.menu-toggle').on('click', function (e) {

                $('#site-navigation').slideToggle('medium');

                $('body').toggleClass('menu-toggle-active');

            });

            $('#site-navigation .menu-item-has-children').append('<span class="sub-toggle"> <i class="fa fa-caret-down" aria-hidden="true"></i> </span>');

            $('#site-navigation .page_item_has_children').append('<span class="sub-toggle"> <i class="fa fa-caret-down" aria-hidden="true"></i> </span>');


            $('#site-navigation .sub-toggle').on('click', function () {

                $(this).toggleClass('active-submenu');

                $(this).parent('.menu-item-has-children').children('ul.sub-menu').first().slideToggle('medium');

                $(this).parent('.page_item_has_children').children('ul.children').first().slideToggle('medium');

                if ($(this).hasClass('active-submenu')) {

                    $(this).find('.fa').removeClass('fa-caret-down').addClass('fa-caret-up');

                } else {

                    $(this).find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
                }

            });


            $('.menu-item a[href="#"]').on('click', function (e) {

                e.preventDefault(); // prevent empty links clicks
            });
        },

        /**
        * Handle canvas aside.
        * 
        * @return void
        * @since 1.0.0
        */
        canvas: function () {

            var canvasRevealBtn = $('#load-comments');
            var canvasAside = $('#comment-canvas');
            var canvasMask = $('.canvas-aside-mask');

            $(canvasRevealBtn).on('click', function () {

                canvasAside.addClass('visible');
                canvasMask.addClass('visible');
            });

            $(canvasMask).on('click', function () {

                canvasAside.removeClass('visible');
                canvasMask.removeClass('visible');
            });
        },

        /**
        *
        * Ajax post load more button.
        *
        * @return void
        * @since 1.0.0
        */
        ajaxLoadPosts: function () {

            let loadContentBtnEle = $('.fb-load-more button');

            $(loadContentBtnEle).on('click', function () {

                $(this).addClass('loading');

                let contentLayout = $(this).val();

                $.ajax({
                    url: fascinate_pro_ajax_script.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'fascinate_pro_load_posts_action',
                        nonce: fascinate_pro_ajax_script.nonce,
                        page: fascinate_pro_ajax_script.current_page,
                        query: fascinate_pro_ajax_script.posts,
                        layout: contentLayout
                    },
                    success: function (response) {

                        if (response) {

                            // Remove loading class.
                            $(loadContentBtnEle).removeClass('loading');

                            switch (contentLayout) {
                                case 'layout_one':
                                    $(response).insertBefore($('.posts-list-style-1 .fb-load-more'));
                                    break;
                                case 'layout_two':
                                    $(response).insertBefore($('.posts-list-style-2 .fb-load-more'));
                                    break;
                                case 'layout_three':
                                    $('.posts-list-style-3 .row').append(response);
                                    break;
                                case 'layout_four':
                                    loadMasonryLayout(response);
                                    break;
                                case 'layout_five':
                                    $(response).insertBefore($('.posts-list-style-5 .row .fb-load-more'));
                                    break;
                                default:
                                    throw new Error('Fascinate pro: Layout not found !');
                            }

                            // Handle pagination.
                            fascinate_pro_ajax_script.current_page++;

                        } else {

                            $('.fb-load-more').hide();
                        }
                    },
                    error: function (error) {

                        $(loadContentBtnEle).removeClass('loading');

                        throw new Error(error);
                    }
                });
            });

            /**
             * Load masory layout.
             *
             * @param {HTML} response
             */
            const loadMasonryLayout = (response) => {

                let postGrid = $('.masonry-row').masonry({

                    itemSelector: '.masonry-article',
                });

                postGrid.append(response);

                postGrid.masonry('reloadItems').masonry('layout');

                postGrid.imagesLoaded().progress(function () {

                    postGrid.masonry('reloadItems').masonry('layout');
                });
            }
        },

        /**
        *
        * Sticky sidebar.
        *
        * @return void
        * @since 1.0.0
        */
        stickySidebar: function () {

            let windowWidth = $(window).width();

            if (windowWidth <= 991) {

                $(".col-lg-8").removeClass("sticky-portion");

            } else {

                $('.sticky-portion').theiaStickySidebar({ additionalMarginTop: 30 });
            }
        },

        /**
        *
        * Sticky header.
        *
        * @return void
        * @since 1.0.0
        */
        stickyHeader: function () {

            let headerEle = $('#fascinate-mastheader');

            if (headerEle.length > 0) {

                // Get header height.
                let headerHeight = headerEle.outerHeight();

                // Get the current scroll value.
                let currentViewport = $(window).scrollTop();

                // Add 60% to the header height.
                let activateStickyHeight = Math.round(headerHeight + ((60 * headerHeight) / 100));

                // Execute sticky header.
                currentViewport >= activateStickyHeight ? $(headerEle).addClass('is-sticky') : $(headerEle).removeClass('is-sticky');
            }
        },

        /**
        *
        * Load all sliders.
        *
        * @return void
        * @since 1.0.0
        */
        loadAllSliders: function () {

            const options = {
                lazyLoad: isLazyLoadEnabled ? 'ondemand' : 'progressive',
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 2000,
                infinite: true,
                nextArrow: ' <a class="slick-nav slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
                prevArrow: ' <a class="slick-nav slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
                rtl: isRTL
            }

            if ($('body').hasClass('boxed')) {

                $("body .slider-tweak").removeClass('slider-1');
                $("body .slider-tweak").addClass('slider-1-single');
            }

            $('.slider-1').slick({
                ...options,
                centerMode: true,
                centerPadding: '400px',
                responsive: [{
                    breakpoint: 1400,
                    settings: {

                        slidesToShow: 1,
                        centerPadding: '250px',

                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        autoplaySpeed: 4000,
                        speed: 800,
                        centerPadding: '0px',
                    }
                },

                {
                    breakpoint: 0,
                    settings: {

                        slidesToShow: 1,
                        autoplaySpeed: 4000,
                        speed: 800,
                        centerPadding: '0px'
                    }
                },
                ]
            });


            $('.slider-1-single').slick({

                ...options,
                centerMode: true,
                centerPadding: '0px',
                responsive: [{
                    breakpoint: 1400,
                    settings: {

                        slidesToShow: 1,
                        centerPadding: '0px',

                    }
                },]
            });


            $('.slider-2').slick({
                ...options,
                centerMode: false,
                slidesToShow: 3,
                responsive: [{
                    breakpoint: 1400,
                    settings: {

                        slidesToShow: 3,
                        centerPadding: '0',

                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        autoplaySpeed: 4000,
                        speed: 800,
                        centerPadding: '0px',
                    }
                },

                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        autoplaySpeed: 4000,
                        speed: 800,
                        centerPadding: '0px',
                    }
                },

                {
                    breakpoint: 0,
                    settings: {

                        slidesToShow: 1,
                        autoplaySpeed: 4000,
                        speed: 800,
                        centerPadding: '0px'
                    }
                },
                ]
            });
        },


        /**
        *
        * Load masonry grid.
        *
        * @return void
        * @since 1.0.0
        */
        loadMasonry: function () {

            let masonry_grid = $('.masonry-row').masonry({

                itemSelector: '.masonry-article',
            });

            masonry_grid.imagesLoaded().progress(function () {

                masonry_grid.masonry();
            });
        },


        /**
        *
        * Watch the visibility of back to top button.
        *
        * @return void
        * @since 1.0.0
        */
        watchBackToTopButtonVisibility: function () {

            let button = $('#fascinate-backtotop');

            if (button.length > 0) {

                // Get the current scroll value.
                let currentViewPort = $(window).scrollTop();

                currentViewPort >= 800 ? $(button).fadeIn('slow') : $(button).fadeOut('slow');
            }
        },

        /**
        *
        * Handle back to top button click.
        *
        * @return void
        * @since 1.0.0
        */
        handleBackToTopEvent: function () {

            let button = $('#fascinate-pro-to-top');

            if (button.length > 0) {

                $(button).on('click', function (e) {

                    e.preventDefault();

                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                });
            }
        },

        /**
        *
        * Handle search button click.
        *
        * @return void
        * @since 1.0.0
        */
        handleSearch: function () {

            $('body').on('click', '.search-icon', function (e) {

                e.preventDefault();

                $('.search-area-container').removeClass('hide-search');
                $('.search-area-container').addClass('show-search');
            });

            $('body').on('click', '.search-close', function (e) {

                e.preventDefault();

                $('.search-area-container').removeClass('show-search');
                $('.search-area-container').addClass('hide-search');
            });
        },

        /**
        *
        * Handle preloader.
        *
        * @return void
        * @since 1.0.0
        */
        preloader: function () {

            if (enablePreloader) {

                $('.preLoader').fadeOut('slow');
            }
        },
    }

    /**
    *
    * List of the javaScript events.
    *
    * @return void
    * @since 1.0.0
    */

    $(window).load(function () {

        FASPRO.preloader();
    });

    $(document).ready(function () {

        FASPRO.ready();
    });

    $(document).scroll(function () {

        FASPRO.scroll();
    });

    $(document).resize(function () {

        FASPRO.resize();
    });

})(jQuery);